<form [formGroup]="formName">
  <div *ngIf="field.autoComplete">
    <mat-form-field appearance="outline" [ngStyle]="{'width.px': 264}">
      <mat-label>{{field.label | uppercase}}</mat-label>
      <input [formControlName]="field.filterKey" [matAutocomplete]="auto" [name]="field.label"
        [placeholder]="field.options[0].label" [value]="field.value" type="text" aria-label="AutoComplete" matInput>
      
        <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>

    </mat-form-field>
  </div>
  <div *ngIf="!field.autoComplete">
    <mat-form-field appearance="outline" [ngStyle]="{'width.px': 168}">
      <mat-label>{{field.label | uppercase}}</mat-label>
      <mat-select [formControlName]="field.filterKey" [disableOptionCentering]="true">
        <mat-option>Clear</mat-option>
        <mat-option *ngFor="let option of field.options" [value]="option.value">
          {{option.label || option.value}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>

<!--


<mat-autocomplete #auto="matAutocomplete">
  <cdk-virtual-scroll-viewport [ngStyle]="{height: '200px'}" itemSize="25">
    <mat-option *cdkVirtualFor="let entry of entries" [value]="entry">
      {{entry}}
    </mat-option>
  </cdk-virtual-scroll-viewport>
</mat-autocomplete> -->
